import { yup } from "@swa-ui/object";

export const MEDICAL_EQUIPMENT_SCHEMA_FIELD_NAMES = {
  PORTABLE_OXYGEN_CONCENTRATOR: "passengerDisabilityOxygen",
};

export const getMedicalEquipmentFormFieldsSchema = (fieldNames = {}) => {
  const { PORTABLE_OXYGEN_CONCENTRATOR } = MEDICAL_EQUIPMENT_SCHEMA_FIELD_NAMES;
  const { portableOxygenConcentrator = PORTABLE_OXYGEN_CONCENTRATOR } = fieldNames;

  return {
    [portableOxygenConcentrator]: yup.boolean(),
  };
};
